/** Public surface of the form-focus-target module. Both platforms' providers build on these. */
import React from 'react'

import { IFormFocusTargetContext } from './form-focus-target'

export { IFocusPathOptions, IFocusTarget, IFormFocusTargetContext } from './form-focus-target'
export {
  IFormFocusHandle,
  FormFocusHandleContext,
  FormFocusHandleSetter,
} from './form-focus-handle'
export { useFormFocusHandle } from './use-form-focus-handle'
export {
  addRegistration,
  nextFocusRegistrationId,
  pickFocusTarget,
  removeRegistration,
} from './focus-target-registry'

const defaultContext: IFormFocusTargetContext = {
  register: () => undefined,
  unregister: () => undefined,
  getRef: () => null,
  getOrderedPaths: () => [],
  focusPath: () => Promise.resolve(false),
  focusFirstError: () => Promise.resolve(undefined),
}

export const FormFocusTargetContext = React.createContext<IFormFocusTargetContext>(defaultContext)
